export default __webpack_public_path__ + "static/media/how-it-works-5.2b6e84cb.png";